// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Avatar } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
import AppCache from '../../../services/appcache';
// ---------------------------------------------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(2, 2.5),
    padding: theme.spacing(0.5, 2.5),
    // borderRadius: Number(theme.shape.borderRadius) * 1.5,
    // backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));
// ---------------------------------------------------------------------------------------------------------

export default function BranchSecretaryNavAccount() {

    const { user } = useAuthContext();
    const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const empRegion = AppCache.GetEmpRegion();
    const userName = `${currentLoggedInUser.UserFirstName} ${currentLoggedInUser.UserLastName}` || currentLoggedInUser.UserName;

    return (
        <StyledRoot>
            <Stack direction='column' justifyContent='space-between' flexGrow={1}>
                {/*  <Avatar src={currentLoggedInUser.ProfileImage} alt="photoURL" />  */}

                <Typography variant="subtitle2" sx={{ color: 'common.black' }}>
                    {userName}
                </Typography>

                <Typography variant="caption" sx={{ color: 'common.black' }}>
                    {currentLoggedInUser.UserRoleName}
                </Typography>

                {/* <Typography variant="subtitle2" sx={{ color: 'common.black', fontSize: 12 }}>
                    Franchise : {empRegion?.Franchise}
                </Typography>

                <Typography variant="subtitle2" sx={{ color: 'common.black', fontSize: 12 }}>
                    Region : {empRegion?.Region}
                </Typography>   */}
            </Stack>
        </StyledRoot>
    );
}
